const SET_ACTIVITIES = 'classpass/movement/SET_ACTIVITIES';

const getInitialState = () => ({
  activities: {},
});

export default function reducer(state = getInitialState(), action = {}) {
  switch (action.type) {
    case SET_ACTIVITIES:
      return {
        ...state,
        activities: {
          ...state.activities,
          [action.data.movementAlias]: action.data.activities,
        },
      };
    default:
      return state;
  }
}

export const setActivities = (movementAlias, activities) => ({
  type: SET_ACTIVITIES,
  data: { movementAlias, activities },
});

export const selectActivitiesForMovement = (state, movementAlias) => state.features.movement.activities[movementAlias];
